export const URL_REGEX = /(https?\:\/\/)?(www\.)?[^\s]+\.[^\s]+/g;
export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
